import { Dispatch, SetStateAction } from 'react';

import { ArrowDownTableIcon, ArrowUpTableIcon } from '@/lib/icon';
import { Flex } from '@/lib/v2/components/Layout/Stack';

interface ITableOrder {
  getTableOrderByList: (element: { id: string; isAsc: boolean | undefined }) => void;
  elementName: string;
  setTableOrderByList?: Dispatch<SetStateAction<{ id: string; isAsc: boolean | undefined }[]>>;
  tableOrderByList?: { id: string; isAsc: boolean | undefined }[];
}

export const SortTableArrow = ({
  getTableOrderByList,
  elementName,
  setTableOrderByList,
  tableOrderByList,
}: ITableOrder) => {
  const selectedElement =
    tableOrderByList && tableOrderByList.find((item) => item.id === elementName);

  const onAction = () => {
    setTableOrderByList &&
      setTableOrderByList((prevState) =>
        prevState.map((button) => {
          return { ...button, isAsc: button.id === elementName ? !button.isAsc : undefined };
        })
      );
    if (selectedElement) {
      getTableOrderByList && getTableOrderByList(selectedElement);
    }
  };
  return (
    <>
      <button className="px-2" onClick={() => onAction()}>
        {selectedElement && selectedElement.isAsc === false ? (
          <Flex column>
            <div className="pb-1">
              <ArrowUpTableIcon />
            </div>
            <div>
              <ArrowDownTableIcon color="#004dbc" />
            </div>
          </Flex>
        ) : selectedElement && selectedElement.isAsc ? (
          <Flex column>
            <div className="pb-1">
              <ArrowUpTableIcon color="#004dbc" />
            </div>
            <div>
              <ArrowDownTableIcon />
            </div>
          </Flex>
        ) : (
          <Flex column>
            <div className="pb-1">
              <ArrowUpTableIcon />
            </div>
            <div>
              <ArrowDownTableIcon />
            </div>
          </Flex>
        )}
      </button>
    </>
  );
};
